import React from "react";
import TrendBadge from "./TrendBadge";
import "../styles/pd.css";

const IconClock = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    className="inline -mt-0.5 mr-1 text-white/90"
  >
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
  </svg>
);

const IconTarget = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    className="inline -mt-0.5 mr-1 text-white/90"
  >
    <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
  </svg>
);

const Tile = ({ label, value, vs, unit="", signature=false }) => {
  const up = Number(vs) > 0;
  const down = Number(vs) < 0;
  const ring = signature ? "ring-1 ring-emerald-400/40" : "";
  return (
    <div className={`flex-1 bg-slate-700 rounded-lg p-3 text-center ${ring}`}>
      <div className="text-lg font-bold">{value}</div>
      <div className="text-xs text-slate-300">{label}</div>
      <div className={`text-xs mt-0.5 ${up ? "text-emerald-400" : down ? "text-rose-400" : "text-slate-400"}`}>
        {up ? "▲" : down ? "▼" : "•"} vs Lg {vs > 0 ? "+" : ""}{vs}{unit}
      </div>
    </div>
  );
};

const PDCard = ({ player }) => {
  return (
    <div className="rounded-2xl border border-white/10 bg-slate-800 text-white shadow-xl p-6 flex flex-col gap-4">
      {/* Header */}
      <div className="flex items-start justify-between">
        <div>
          <h2 className="text-xl font-bold">{player.name}</h2>
          {player.identityTag && (
            <div className="text-xs text-slate-300 mt-1">{player.identityTag}</div>
          )}
        </div>
      </div>


      {/* Strengths / Improvements */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3 className="text-sm font-semibold text-white mb-2">Key Strengths</h3>
          <div className="border-b border-slate-600 mb-3"></div>
          <ul className="text-sm space-y-2">{player.strengths.map((s,i)=><li key={i} className="flex items-start"><span className="text-white mr-2">•</span><span>{s}</span></li>)}</ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold text-white mb-2">Areas to Improve</h3>
          <div className="border-b border-slate-600 mb-3"></div>
          <ul className="text-sm space-y-2">{player.improvements.map((i2,i)=><li key={i} className="flex items-start"><span className="text-white mr-2">•</span><span>{i2}</span></li>)}</ul>
        </div>
      </div>

      {/* Goals */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3 className="text-sm font-semibold text-white mb-2">Goals</h3>
          <div className="border-b border-slate-600 mb-3"></div>
          <ul className="text-sm space-y-2">{player.goalsShort.map((g,i)=><li key={i} className="flex items-start"><span className="text-white mr-2">•</span><span>{g}</span></li>)}</ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold text-white mb-2">Long-Term Projection</h3>
          <div className="border-b border-slate-600 mb-3"></div>
          <ul className="text-sm space-y-2">{player.goalsLong.map((g,i)=><li key={i} className="flex items-start"><span className="text-white mr-2">•</span><span>{g}</span></li>)}</ul>
        </div>
      </div>

      {/* Development Tiles */}
      {player.developmentTiles?.length > 0 && (
        <div className="space-y-3 mt-2">
          {player.developmentTiles.map((tile, i) => (
            <div key={i} className="bg-slate-700/30 rounded-lg p-3 border border-slate-600/20">
              <div className="text-sm font-semibold text-white mb-1">{tile.label}</div>
              <div className="text-xs text-slate-300 leading-relaxed">{tile.value}</div>
            </div>
          ))}
        </div>
      )}
      
      {/* Fallback to old tiles if no development tiles */}
      {!player.developmentTiles && player.tiles?.length > 0 && (
        <div className="flex gap-4 mt-1">
          {player.tiles.map((t,i)=>(
            <Tile key={i} label={t.label} value={t.value} vs={t.vs} unit={t.unit} signature={t.signature}/>
          ))}
        </div>
      )}
    </div>
  );
};

export default PDCard;
